import { render, staticRenderFns } from "./MyTagDetail.vue?vue&type=template&id=5af476d9&scoped=true"
import script from "./MyTagDetail.vue?vue&type=script&lang=js"
export * from "./MyTagDetail.vue?vue&type=script&lang=js"
import style0 from "./MyTagDetail.vue?vue&type=style&index=0&id=5af476d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af476d9",
  null
  
)

export default component.exports